import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import "../forget.scss";

export default function ForgetForm({
  initialValues,
  title,
  send,
  error,
  loading,
}) {
  const [emailVerification, setEmailVerification] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [values, setValues] = useState(initialValues);

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setEmailVerification(false);
    localStorage.setItem("email", values.email);

    let emailVerification = new RegExp(
      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    ).test(values.email);

    if (emailVerification === false) {
      setEmailVerification(true);
    }

    send(values);
  };

  let history = useHistory();

  function handleClick() {
    history.push("/nova-senha");
  }

  return (
    <>
      <div className="form-container">
        <div className="welcome-title">
          <h1>
            Seja bem vindo à <b className="text-primary">CTAG</b>
          </h1>
        </div>

        <p className="welcome-info">
          Nós enviaremos um e-mail com o link para uma nova senha
        </p>

        <form onSubmit={handleClick}>
          <div className="group-input ">
            <input
              placeholder="E-mail"
              className={`global-input ${
                submitted && !values.email ? "error" : ""
              }`}
              id="email"
              name="email"
              value={values.email}
              onChange={handleChange}
            />

            <div className="error-container">
              {emailVerification && (
                <b className="error-msg">Usuário não encontrado</b>
              )}
            </div>
          </div>

          <div className="footer-form-container">
            <span>
              Ou{" "}
              <b>
                <Link to="/login" className="text-dark-light text-decoration-none">
                  Login
                </Link>
              </b>
            </span>

            <button className="global-btn-secondary" >
              ENVIAR
              {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
            </button>
          </div>
        </form>
      </div>

      {/* <div className="forget-container">
        {error && <span className="error-list">{error && error}</span>}
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="header-container">
            <div className="public-app-item">
              <h1>{title}</h1>
            </div>
            <div className="public-app-item">
              <p>
                {" "}
                ou <a href="/login">login</a>{" "}
              </p>
            </div>
          </div>
          <div className="group-input">
            <input
              placeholder="Email"
              className={`global-input ${
                submitted && !values.email ? "error" : ""
              }`}
              id="email"
              name="email"
              value={values.email}
              onChange={handleChange}
            />
            {submitted && !values.email && (
              <span className="error-msg">Esse campo é necessario</span>
            )}
            {emailVerification && (
              <span className="error-msg">Insira um e-mail válido</span>
            )}
          </div>
          <button className="global-btn">
            Enviar {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
          </button>
        </form>
      </div> */}
    </>
  );
}
